var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-scroll-y-reverse-transition',{attrs:{"hide-on-leave":""}},[(_vm.triggerTransition)?_c('v-container',{staticClass:"pa-0 mb-10"},[_vm._t("default")],2):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }